"use strict";

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = void 0 && (void 0).__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = void 0 && (void 0).__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MetaTextRequired = void 0;
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var spaui_utils_1 = require("@tencent/spaui-utils");
var odc_help_tips_1 = __importDefault(require("@tencent/odc-help-tips"));
var info_1 = __importDefault(require("./info"));
var MetaTextRequired = function MetaTextRequired(_a) {
  var className = _a.className,
    style = _a.style;
  return react_1["default"].createElement("i", {
    className: (0, classnames_1["default"])('odc-text-required', className),
    style: style
  }, react_1["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 8
  }, react_1["default"].createElement("path", {
    fill: "currentColor",
    d: "M3.344.576h1.568L4.72 3.472l2.64-1.088.496 1.472-2.784.736 1.92 2.128-1.216.96-1.648-2.416L2.48 7.68l-1.216-.96 1.92-2.128L.4 3.856l.496-1.472 2.64 1.088L3.344.576z"
  })));
};
exports.MetaTextRequired = MetaTextRequired;
// 兼容参数
var compactProps = function compactProps(props) {
  if (props === void 0) {
    props = {};
  }
  var label = props.label,
    text = props.text;
  var labelForProps = '';
  // 有label的时候优先用，没有再看text
  if (typeof label !== 'undefined') {
    labelForProps = label;
  } else {
    labelForProps = text || '';
  }
  return __assign(__assign({}, props), {
    label: labelForProps
  });
};
var MetaName = function MetaName(props, ref) {
  var _a;
  var _b = compactProps(props),
    label = _b.label,
    labelClassName = _b.labelClassName,
    tip = _b.tip,
    children = _b.children,
    labelStyle = _b.labelStyle,
    tipClassName = _b.tipClassName,
    tipStyle = _b.tipStyle,
    ignorePopMaxWidth = _b.ignorePopMaxWidth,
    ignorePopPadding = _b.ignorePopPadding,
    popPlacement = _b.popPlacement,
    _c = _b.show,
    show = _c === void 0 ? true : _c,
    popoverProps = _b.popoverProps,
    overlayTriggerProps = _b.overlayTriggerProps,
    multiline = _b.multiline,
    icon = _b.icon,
    _d = _b.iconSize,
    iconSize = _d === void 0 ? 16 : _d,
    _e = _b.iconValign,
    iconValign = _e === void 0 ? -3 : _e,
    iconClassName = _b.iconClassName,
    _f = _b.iconGap,
    iconGap = _f === void 0 ? 4 : _f,
    endIcon = _b.endIcon,
    suffix = _b.suffix,
    _g = _b.required,
    required = _g === void 0 ? false : _g;
  var helpTipsPopOverProps = (0, react_1.useMemo)(function () {
    return __assign({
      className: tipClassName,
      style: tipStyle
    }, popoverProps);
  }, [tipClassName, tipStyle, popoverProps]);
  if (!show) {
    return null;
  }
  var cssObj = (_a = {}, _a['--odc-icon-size'] = (0, spaui_utils_1.pxVal)(iconSize), _a['--odc-icon-gap'] = (0, spaui_utils_1.pxVal)(iconGap), _a);
  return react_1["default"].createElement("div", __assign({}, (0, spaui_utils_1.globalProps)(props, {
    className: (0, classnames_1["default"])('meta-name', {
      multiline: multiline
    }),
    supportAllEvents: true,
    ref: ref
  }, MetaName)), label ? react_1["default"].createElement("label", {
    className: (0, classnames_1["default"])('meta-name-label', {
      'with-icon': icon
    }, labelClassName),
    style: __assign(__assign({}, (0, spaui_utils_1.removeUndefined)(cssObj)), labelStyle)
  }, icon ? react_1["default"].createElement("i", {
    className: (0, classnames_1["default"])("mr-".concat(iconGap), "align-".concat(iconValign), iconClassName)
  }, icon) : null, label) : null, tip ? react_1["default"].createElement(odc_help_tips_1["default"], {
    tips: tip,
    PopOverProps: helpTipsPopOverProps,
    OverlayTriggerProps: overlayTriggerProps,
    ignorePopMaxWidth: ignorePopMaxWidth,
    ignorePopPadding: ignorePopPadding,
    popPlacement: popPlacement
  }) : null, endIcon, children, required ? react_1["default"].createElement(exports.MetaTextRequired, null) : null, suffix);
};
(0, spaui_utils_1.setComponentMark)(MetaName, info_1["default"]);
exports["default"] = react_1["default"].memo((0, react_1.forwardRef)(MetaName));